export enum HourFormat {
    Twelve = 'Twelve',
    TwentyFour = 'TwentyFour',
}
